import { v4 as uuidv4 } from 'uuid';

export const addObjRefId = (obj) => {
  if (!obj) {
    console.error('obj is required in generateObjectUuid');
    return;
  }

  const giottoProps = obj.get('giotto') ?? {};

  if (giottoProps && giottoProps.objRefId) {
    return;
  }

  obj.set({
    giotto: {
      ...giottoProps,
      objRefId: `${obj.type ? obj.type.toLowerCase() : 'object'}-${uuidv4()}`,
    },
  });
};
